import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4315e11b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "udc-select" }
const _hoisted_2 = { class: "options" }
const _hoisted_3 = ["onClick"]

import { ref, computed, watch, PropType, onMounted } from 'vue'
import { find } from 'lodash'
import $ from 'jquery'

type Option = {
  label: string
  value: string
}

export default /*#__PURE__*/_defineComponent({
  props: {
  rows: {
    type: Array as PropType<Option[]>,
    default: () => [],
  },
  modelValue: {
    type: String,
  },
},
  emits: ['update:modelValue', 'change'],
  setup(__props, { emit }) {

const props = __props





const open = ref<boolean>(false)
const selected = ref<string | undefined>(props.modelValue)
const firstClick = ref<boolean>(true)

const selectedLabel = computed(() => {
  if (props.rows.length === 0) {
    return ''
  }

  if (props.modelValue) {
    const row = props.rows.find(o => o.value === props.modelValue)

    return row?.label
  }

  if (!selected.value) return find(props.rows)?.label

  return find(props.rows, { value: selected.value })?.label
})

const select = (value: string) => {
  open.value = false
  selected.value = value
}

const handleClickSelect = () => {
  open.value = !open.value
  firstClick.value = false
}

const changeSelectHeight = () => {
  const countryOptions = $('.country .options')
  const countryOptionLength = $('.country .options .option').length
  const dateOptions = $('.date .options')
  const dateOptionLength = $('.date .options .option').length

  if ($('div').hasClass('sp')) {
    if (dateOptionLength > 5) {
      dateOptions.css('height', 200)
      dateOptions.removeClass('hide-scroll')
    } else {
      dateOptions.css('height', 35 * dateOptionLength + 1)
      dateOptions.addClass('hide-scroll')
    }
    if (countryOptionLength > 5) {
      countryOptions.css('height', 200)
      countryOptions.removeClass('hide-scroll')
    } else {
      countryOptions.css('height', 35 * countryOptionLength + 1)
      countryOptions.addClass('hide-scroll')
    }
  } else {
    if (dateOptionLength > 8) {
      dateOptions.css('height', 200)
      dateOptions.removeClass('hide-scroll')
    } else {
      dateOptions.css('height', 25 * dateOptionLength + 1)
      dateOptions.addClass('hide-scroll')
    }
    if (countryOptionLength > 8) {
      countryOptions.css('height', 200)
      countryOptions.removeClass('hide-scroll')
    } else {
      countryOptions.css('height', 25 * countryOptionLength + 1)
      countryOptions.addClass('hide-scroll')
    }
  }
}

onMounted(() => {
  changeSelectHeight()
})

watch(
  () => selected.value,
  () => {
    emit('update:modelValue', selected.value)
    emit('change', selected.value)
    changeSelectHeight()
  }
)

watch(
  () => props.modelValue,
  () => {
    if (props.modelValue) {
      selected.value = props.modelValue
    }
  }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(selectedLabel))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: handleClickSelect,
          class: "selected"
        }, _toDisplayString(_unref(selectedLabel)), 1))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (option, index) => {
        return (_openBlock(), _createElementBlock("div", {
          onClick: ($event: any) => (select(option.value)),
          class: "option",
          key: index
        }, _toDisplayString(option.label), 9, _hoisted_3))
      }), 128))
    ], 512), [
      [_vShow, open.value]
    ])
  ]))
}
}

})